export enum Pages {
    SINGIN = '/',
    PIN = '/signin',
    SIGNUP = '/signup',
    NOT_FOUND = '/404',
    HOME = '/wallet',
    REWARDS = '/rewards',
    SETTINGS = '/settings',
    PRODUCT_DETAILS = ':productId'
}
